/**
 * P3-42: ApplyPendingBtn —— 应用待处理挑战按钮。
 *
 * 对齐 `js/challenges.js:1250-1266`：
 * - pending > 0 时可见
 * - 名字随 pending 数量变化
 * - 点击调用 `game.challenges.applyPending()`（确认弹窗由旧引擎处理）
 */
import { getGame } from "../../bridge/GameBridge";
import type { GamePage } from "../../bridge/GameBridge";
import { useGameTick } from "../../bridge/useGameTick";
import { t } from "../../bridge/i18n";
import { GameButton } from "../../components/GameButton";

interface ApplyPendingSnapshot {
  visible: boolean;
  name: string;
  description: string;
}

function getSnapshot(game: GamePage | null): ApplyPendingSnapshot | null {
  if (!game) {
    return null;
  }
  const count = game.challenges?.getCountPending?.() ?? 0;
  return {
    visible: count > 0,
    name: t("challendge.applyPending.label", [count]),
    description: t("challendge.applyPending.desc"),
  };
}

function snapEq(a: ApplyPendingSnapshot | null, b: ApplyPendingSnapshot | null): boolean {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return (
    a.visible === b.visible &&
    a.name === b.name &&
    a.description === b.description
  );
}

export default function ApplyPendingBtn() {
  const snapshot = useGameTick(
    (game) => getSnapshot(game as GamePage | null),
    snapEq,
  );

  if (!snapshot || !snapshot.visible) {
    return null;
  }

  return (
    <GameButton
      name={snapshot.name}
      description={snapshot.description}
      getTooltip={() => snapshot.description}
      onClick={() => {
        getGame()?.challenges?.applyPending?.();
      }}
    />
  );
}
